import gql from 'graphql-tag';

export const archiveDocumentMutation = gql`
  mutation ArchiveDocument(
    $file: Upload!
    $name: String!
    $type: DocumentType
    $value: Float
    $companyName: String
    $companyNumber: String
    $contractStartDate: String
    $contractEndDate: String
    $signDate: String
    $ownerId: String!
  ) {
    archiveDocument(
      file: $file
      name: $name
      type: $type
      value: $value
      companyName: $companyName
      companyNumber: $companyNumber
      contractStartDate: $contractStartDate
      contractEndDate: $contractEndDate
      signDate: $signDate
      ownerId: $ownerId
    ) {
      id
    }
  }
`;

export const updateDocumentOwnerMutation = gql`
  mutation UpdateDocumentOwner($userId: String!, $documentId: String!) {
    updateDocumentOwner(userId: $userId, documentId: $documentId) {
      id
      user {
        id
      }
    }
  }
`;

export const changeDocumentsFolderMutation = gql`
  mutation ChangeDocumentFolder($documentIds: [String!]!, $folderId: String) {
    changeDocumentFolder(documentIds: $documentIds, folderId: $folderId) {
      succeededDocumentIds
      failedDocumentIds
    }
  }
`;

export const deleteDocumentsMutation = gql`
  mutation DeleteDocuments($ids: [String!]!) {
    deleteDocuments(ids: $ids) {
      id
    }
  }
`;

export const updateFolderMutation = gql`
  mutation UpdateFolder($folderId: String!, $name: String!) {
    updateFolder(folderId: $folderId, name: $name) {
      id
      name
    }
  }
`;

export const createFolderMutation = gql`
  mutation CreateFolder($name: String!, $parentFolderId: String) {
    createFolder(name: $name, parentFolderId: $parentFolderId) {
      id
      name
      parentHashId
    }
  }
`;

export const addTagsMutation = gql`
  mutation AddDocumentTags($documentIds: [String!]!, $tagIds: [String!]!) {
    addDocumentTags(documentIds: $documentIds, tagIds: $tagIds) {
      tag {
        id
      }
      document {
        id
      }
    }
  }
`;

export const removeTagsMutation = gql`
  mutation RemoveDocumentTags($documentIds: [String!]!, $tagIds: [String!]!) {
    removeDocumentTags(documentIds: $documentIds, tagIds: $tagIds)
  }
`;

export const createTagMutation = gql`
  mutation CreateDocumentTag($title: String!) {
    createTag(title: $title) {
      id
      title
      status
    }
  }
`;

export const addNotificationMutation = gql`
  mutation CreateDocumentNotification(
    $userId: String!
    $documentIds: [String!]
    $notificationType: DocumentNotificationType
    $notificationNote: String!
    $notificationDate: String!
  ) {
    createDocumentNotification(
      userId: $userId
      documentIds: $documentIds
      notificationType: $notificationType
      notificationNote: $notificationNote
      notificationDate: $notificationDate
    ) {
      id
      notificationType
      notificationNote
      notificationDate
      user {
        email
        id
      }
      document {
        name
        id
      }
    }
  }
`;

export const updateNotificationMutation = gql`
  mutation UpdateDocumentNotification(
    $id: String!
    $userId: String!
    $documentId: String!
    $notificationType: DocumentNotificationType
    $notificationNote: String!
    $notificationDate: String!
  ) {
    updateDocumentNotification(
      id: $id
      userId: $userId
      documentId: $documentId
      notificationType: $notificationType
      notificationNote: $notificationNote
      notificationDate: $notificationDate
    ) {
      id
      notificationType
      notificationNote
      notificationDate
      user {
        email
        id
      }
      document {
        name
        id
      }
    }
  }
`;

export const deleteNotificationMutation = gql`
  mutation DeleteDocumentNotification($id: String!) {
    deleteDocumentNotification(id: $id) {
      id
    }
  }
`;

export const createDocumentNotification = gql`
  mutation CreateDocumentNotification(
    $documentIds: [String!]!
    $notificationDate: String!
    $notificationNote: String!
    $notificationType: DocumentNotificationType!
    $userId: String!
  ) {
    createDocumentNotification(
      documentIds: $documentIds
      notificationDate: $notificationDate
      notificationNote: $notificationNote
      notificationType: $notificationType
      userId: $userId
    ) {
      id
      document {
        id
        name
      }
      notificationDate
      notificationNote
      notificationType
      user {
        id
      }
    }
  }
`;

export const deleteDocumentNotificationMutation = gql`
  mutation DeleteDocumentNotifications($ids: [String!]!) {
    deleteDocumentNotifications(ids: $ids)
  }
`;

export const deleteFolderMutation = gql`
  mutation DeleteFolder($id: String!) {
    deleteFolder(id: $id) {
      id
      name
    }
  }
`;

export const editDocumentsMutation = gql`
  mutation UpdateDocuments(
    $expirationDate: String
    $value: Float
    $userId: String
    $contractStartDate: String
    $contractEndDate: String
    $documentIds: [String!]!
  ) {
    updateDocuments(
      documentUpdate: {
        expirationDate: $expirationDate
        value: $value
        newUserId: $userId
        contractStartDate: $contractStartDate
        contractEndDate: $contractEndDate
        documentIds: $documentIds
      }
    ) {
      id
    }
  }
`;
